var _path, _path2, _rect, _path3, _rect2, _g, _g2, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecentBoilerOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_4",
    "data-name": 4,
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.5,
    height: 53.48,
    viewBox: "0 0 61.5 53.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M0,0H2.263V5.795H17.075V7.939H0Z",
    transform: "translate(11.447 40.797)",
    fill: "#e2e4e5",
    stroke: "#e2e4e5",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M.96,0H31.127a.96.96,0,0,1,.96.96V39.247a.96.96,0,0,1-.96.96H.96a.96.96,0,0,1-.96-.96V.96A.96.96,0,0,1,.96,0Z",
    transform: "translate(27.928 12.793)",
    fill: "#e2e4e5",
    stroke: "#e2e4e5",
    strokeMiterlimit: 10,
    strokeWidth: 0.96
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 25.551,
    height: 34.724,
    rx: 0.96,
    transform: "translate(31.493 15.839)",
    fill: "#fff",
    stroke: "#3a484d",
    strokeMiterlimit: 10,
    strokeWidth: 0.96
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M6,0h8.8a6,6,0,0,1,6,6V36.034a6,6,0,0,1-6,6H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0Z",
    fill: "#e2e4e5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    width: 16.043,
    height: 37.161,
    rx: 2,
    transform: "translate(2.377 2.437)",
    fill: "#fff",
    stroke: "#3a484d",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flame",
    transform: "translate(35.061 41.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M1.28,7.9A6.134,6.134,0,0,1,.254,6.417,3.449,3.449,0,0,1,.06,4.478,4.232,4.232,0,0,1,.873,2.683,1.756,1.756,0,0,0,1.3,3.952a3.07,3.07,0,0,1,.672-2.5A5.045,5.045,0,0,1,4.126,0a1.822,1.822,0,0,0-.3,1.7,7.176,7.176,0,0,0,.8,1.613,3.657,3.657,0,0,1,.6,1.668,5.9,5.9,0,0,0,.442-.961,1.944,1.944,0,0,0,.071-1.051,2.728,2.728,0,0,1,.583,1.305,5.623,5.623,0,0,1,.018,1.541,3.921,3.921,0,0,1-.513,1.613A2.961,2.961,0,0,1,4.286,8.611,3.432,3.432,0,0,1,1.28,7.9Z",
    transform: "translate(0)",
    fill: "#f3705a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M1.168,4.913A1.769,1.769,0,0,0,3.255,2.375c0-.018-.018-.018-.018-.036a1.861,1.861,0,0,1-.442,1.6,1.731,1.731,0,0,0-.159-1.378c-.212-.417-.513-.8-.743-1.2A1.966,1.966,0,0,1,1.593,0,2.4,2.4,0,0,0,.744,1.341a2.482,2.482,0,0,0,.177,1.6,1.2,1.2,0,0,1-.477-.87A1.9,1.9,0,0,0,0,3.317,1.842,1.842,0,0,0,1.168,4.913Z",
    transform: "translate(1.455 3.662)",
    fill: "#ffd15c"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "drop",
    transform: "translate(47.546 42.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M3,2.819l0,0L1.579.019a.034.034,0,0,0-.061,0L.1,2.815l0,0A1.663,1.663,0,0,0,.145,4.07a1.6,1.6,0,0,0,.893.853,1.557,1.557,0,0,0,.509.1h0a1.558,1.558,0,0,0,.509-.1,1.6,1.6,0,0,0,.893-.853A1.663,1.663,0,0,0,3,2.819Z",
    transform: "translate(0 0)",
    fill: "#c4d1e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0 0.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M1.658,4.7a1.839,1.839,0,0,1-.531-1.288.038.038,0,0,1,0,0L1.507,0,.1,2.773l0,0A1.663,1.663,0,0,0,.145,4.028a1.6,1.6,0,0,0,.893.853,1.557,1.557,0,0,0,.509.1h0a1.555,1.555,0,0,0,.375-.058A1.812,1.812,0,0,1,1.658,4.7Z",
    transform: "translate(0 0)",
    fill: "#acb9ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M1.51,1.4l0,0L.811.019a.034.034,0,0,0-.061,0L.053,1.4l0,0a.838.838,0,0,0,.022.63.807.807,0,0,0,.45.43.785.785,0,0,0,.257.052h0a.786.786,0,0,0,.257-.052A.831.831,0,0,0,1.51,1.4Z",
    transform: "translate(3.675 2.126)",
    fill: "#acb9ce"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M1.006,1.4l0,0L.307.019A.034.034,0,0,0,.276,0h0L0,1.637v0A.916.916,0,0,0,.229,2.3a.891.891,0,0,0,.234.189c.024-.007.048-.014.071-.023A.831.831,0,0,0,1.006,1.4Z",
    transform: "translate(4.179 2.167)",
    fill: "#c4d1e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M1.027.937.562.019A.034.034,0,0,0,.5.019L.036.937l0,0a.566.566,0,0,0,.321.722A.536.536,0,0,0,.53,1.7h0a.535.535,0,0,0,.175-.035A.566.566,0,0,0,1.028.941Z",
    transform: "translate(2.768 4.809)",
    fill: "#acb9ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    d: "M.7.941l0,0L.233.019A.034.034,0,0,0,.2,0L.192,0,0,1.153a.04.04,0,0,0,0,0,.64.64,0,0,0,.248.537.536.536,0,0,0,.13-.032A.566.566,0,0,0,.7.941Z",
    transform: "translate(3.097 4.809)",
    fill: "#c4d1e6"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M0,0H15.174A2.257,2.257,0,0,1,17.4,2.284h0a2.257,2.257,0,0,1-2.228,2.284H11.356A2.111,2.111,0,0,0,9.272,6.706h0a2.111,2.111,0,0,0,2.085,2.137H20.2",
    transform: "translate(24.659 18.276)",
    fill: "none",
    stroke: "#f3735a",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M0,0H8.356a2.106,2.106,0,0,1,2.08,2.132h0a2.106,2.106,0,0,1-2.08,2.132H4.225A2.106,2.106,0,0,0,2.145,6.4h0a2.106,2.106,0,0,0,2.08,2.132H16.638",
    transform: "translate(44.862 27.119)",
    fill: "none",
    stroke: "#00a3da",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    d: "M.5,23.659V0",
    transform: "translate(44.362 26.687)",
    fill: "none",
    stroke: "#3a484d",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.05
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentBoilerOff);
export default __webpack_public_path__ + "static/media/recent-boiler-off.bb75ac1f51b4e05ec3cc2b3ae5b5cd22.svg";
export { ForwardRef as ReactComponent };